<template>
    <div class="briefShopInfoMain">
        <div style="height: 10px;"></div>

        <div class="contentWrapper">
            <div style="display: flex; align-items: center;width: 100%;">
                <div style="flex-grow: 1;overflow-x: hidden;">
                    <span class="shopNickname" @click="goAuthTest">{{
                        shopInfo ? shopInfo.shopNickname : ""
                    }}</span>

                    <div class="anouncement">
                        <div style="flex-shrink: 0;" class="label">公告: </div>
                        <BaseAutoHorizonScroll :text="shopInfo ? shopInfo.shopAnnouncement : ''" style="flex-grow: 1;white-space: nowrap;overflow-y: auto;" class="content" />
                    </div>
                </div>
                <img
                    loading="lazy"
                    class="shopImg"
                    :src="getImgUrl(shopInfo ? shopInfo.shopLogo : '')"
                />
            </div>

            <template v-if="description.discountInfoList != null && description.discountInfoList.length > 0">
                <div class="horizonGully" />

                <div class="couponWrapper" @click="ifShowCoupon = false" v-if="ifShowCoupon">
                    <div>点击隐藏</div>
                    <div>
                        <div
                            v-for="({ img, icon, content }, index) of description.discountInfoList ? description.discountInfoList : []"
                            :key="'discountInfoList' + index"
                        >
                            <img
                                v-if="img"
                                class="couponImg"
                                :src="`${getShopStaticResouceUrl()}${img}`"
                            />
                            <i
                                style="vertical-align: middle;"
                                v-else-if="icon"
                                :class="['iconfont', icon]"
                            ></i>
                            <span style="vertical-align: middle;">{{ content }}</span>
                        </div>
                    </div>

                    <div
                        @click="
                            goToMyCoupons
                        "
                    >
                        <div style="display: inline-block;">
                            <img
                                :src="getImgUrl('/images/red-packet.gif')"
                                class="couponRedEnvelopImg"
                            />
                            <span style="vertical-align: middle;">
                                {{description.coupons ? description.coupons.content : ''}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="couponWrapper" @click="ifShowCoupon = true" v-else>
                    <span>点击显示更多优惠</span>
                    <div style="flex-grow: 1;white-space: nowrap;overflow: hidden;">{{ description.discountInfoList[0].content }}</div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>

//
import { mapState, mapGetters, } from 'vuex'

export default {
    name: 'BriefShopInfo',

    data() {
        return {
            ifShowCoupon: false,

            //
            goAuthTestClickTimes: 0,
            goAuthTestClickTimeout: null,
        }
    },

    computed: {
        ...mapState({
            shopInfo: (state) => state.shop.shopInfo,
            description: (state) => state.description.description,
        }),
    },

    methods: {
        goAuthTest()
        {
            if(this.goAuthTestClickTimeout != null)
            {
                clearTimeout(this.goAuthTestClickTimeout)
            }

            if(this.goAuthTestClickTimes ++ >= 10)
            {
                return this.$router.push({
                    path: "yqyTest",
                });
            }

            this.goAuthTestClickTimeout = setTimeout(() => {
                //
                this.goAuthTestClickTimeout = null;

                //
                this.goAuthTestClickTimes = 0;
            }, 1000);
        },

        goToMyCoupons()
        {
            this.$router.push({
                path: '/myCoupons'
            });
        },
    },
}
</script>

<style lang="scss" scoped>

.briefShopInfoMain {
    width: 100%;
    font-size: $fontSizeContent;
    line-height: 2em;
}

.contentWrapper {
    background: #ffffff;
    box-sizing: border-box;
    border-radius: $borderRadius;
    padding: 0 $padding;
    padding-bottom: $padding;
}

.shopNickname
{
    font-size: $fontSizeTitle;
    line-height: 2em;
    font-weight: 800;
    white-space: nowrap;
    overflow-y: auto;
}

.anouncement
{
    font-size: 0.8em; 
    line-height: 2em;
    display: flex;
    align-items: center;

    .label {
        color: $primaryColor;
        margin-right: 1em;
        font-weight: 800;
    }

    .content {
        color: $functionalFontAlertColor;
    }
}

.shopImg
{
    flex-shrink: 0;
    width: calc(2 * #{$fontSizeTitle} + 2 * #{$fontSizeFootNote} + #{$fontSizeTitle});
    border-radius: $borderRadius;
    margin-top: -$fontSizeTitle;
    margin-left: 0.4em;
}

//
.couponWrapper
{
    font-size: $fontSizeCaption; 
    line-height: 2em;
    color: $functionalFontAlertColor;
}

.couponImg
{
    width: 1em;
    height: 1em;
    vertical-align: middle;
}

.couponRedEnvelopImg
{
    @extend .couponImg;

    width: 2em;
    height: 2em;
}
</style>